import Swiper from "swiper";
import { find } from "../utils/dom";

import observeSection from "../modules/observeSection";

const PageLandingPage = () =>{
	const Page = find("[js-page='home']");
	if (!Page) return




	const SwiperBeneficios = new Swiper(".swiper-beneficios", {
		slidesPerView: "auto",
		spaceBetween: 32,
		freeMode: true,
		pagination: {
			el: ".swiper-pagination-beneficios",
			type: "progressbar",
		},
		navigation: {
			nextEl: ".swiper-next-beneficio",
			prevEl: ".swiper-prev-beneficio",
		},
	})


	observeSection();

}

export default PageLandingPage;